import React from "react";
import { Link } from "react-router-dom";
import "../styles/Services.css";

import carWash from "../images/services/cw.jpg";
import carpet from "../images/services/carpet.png";
import water from "../images/services/wr.jpg";
import { useEffect } from "react";
import { useRef } from "react";

const services = [
  {
    title: "Car Wash",
    desc: "Professional interior and exterior car wash services to keep your vehicle clean, fresh, and sharp.",
    image: carWash,
    link: "/carwash-appointment",
  },
  {
    title: "Carpet Cleaning",
    desc: "Deep carpet cleaning with same-day pick-up and delivery, removing stains and leaving long-lasting freshness.",
    image: carpet,
    link: "/carpet-pickup",
  },
  {
    title: "Water Refill",
    desc: "Clean and safe water refill service at KSh 5 per litre, with convenient booking and free delivery to your doorstep.",
    image: water,
    link: "/water-refill",
  },
];

const Services = () => {

 const servicesRef = useRef(null);

useEffect(() => {
  const revealElements =
    servicesRef.current?.querySelectorAll("[data-reveal]") || [];

  const scrollReveal = () => {
    revealElements.forEach((el) => {
      const elementIsInScreen =
        el.getBoundingClientRect().top < window.innerHeight / 1.15;

      if (elementIsInScreen) {
        el.classList.add("revealed");
      } else {
        el.classList.remove("revealed");
      }
    });
  };

  window.addEventListener("scroll", scrollReveal);
  scrollReveal(); // run on load

  return () => {
    window.removeEventListener("scroll", scrollReveal);
  };
}, []);


  return (
    <main className="services-page" ref={servicesRef}>
      <section className="services-hero">
        <span data-reveal>Our services</span>
        <h1 data-reveal>What We Offer</h1>
        <p data-reveal>
          Book reliable car wash, carpet cleaning, and water refill services
          from Savannah Shine Hub.
        </p>
      </section>

      <section className="services-list-section">
        <div className="services-list">
          {services.map((service, index) => (
            <div className="services-card" key={index}>
              <img src={service.image} alt={service.title} />

              <div className="services-card-content">
                <h3 data-reveal>{service.title}</h3>
                <p data-reveal>{service.desc}</p>

                <Link to={service.link} className="services-book-btn" >
                  Book Now
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Services;